export const pressedStyle = `
  transform: translateY(2px);
`;
export const activePressedStyle = `
  &:active {
    ${pressedStyle}
  }
`;